import _defineProperty from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["elementType", "children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useSlotProps as $bJbxN$useSlotProps, useStyleProps as $bJbxN$useStyleProps, viewStyleProps as $bJbxN$viewStyleProps, useDOMRef as $bJbxN$useDOMRef, ClearSlots as $bJbxN$ClearSlots } from "@react-spectrum/utils";
import { filterDOMProps as $bJbxN$filterDOMProps } from "@react-aria/utils";
import $bJbxN$react, { forwardRef as $bJbxN$forwardRef } from "react";
function $b9606c0c41d55371$var$View(props, ref) {
  props = $bJbxN$useSlotProps(props);
  var _props = props,
    _props$elementType = _props.elementType,
    ElementType = _props$elementType === void 0 ? 'div' : _props$elementType,
    children = _props.children,
    otherProps = _objectWithoutProperties(_props, _excluded);
  var _$bJbxN$useStyleProps = $bJbxN$useStyleProps(props, $bJbxN$viewStyleProps),
    styleProps = _$bJbxN$useStyleProps.styleProps;
  var domRef = $bJbxN$useDOMRef(ref);
  return /*#__PURE__*/$bJbxN$react.createElement(ElementType, _objectSpread(_objectSpread(_objectSpread({}, $bJbxN$filterDOMProps(otherProps)), styleProps), {}, {
    ref: domRef
  }), /*#__PURE__*/$bJbxN$react.createElement($bJbxN$ClearSlots, null, children));
}
/**
 * View is a general purpose container with no specific semantics that can be used for custom styling purposes.
 * It supports Spectrum style props to ensure consistency with other Spectrum components.
 */
var $b9606c0c41d55371$export$27a5bd065ad55220 = /*#__PURE__*/$bJbxN$forwardRef($b9606c0c41d55371$var$View);
function $0a7c18a2ef74b280$var$Content(props, ref) {
  props = $bJbxN$useSlotProps(props, 'content');
  var _props2 = props,
    children = _props2.children,
    otherProps = _objectWithoutProperties(_props2, _excluded2);
  var _$bJbxN$useStyleProps2 = $bJbxN$useStyleProps(otherProps),
    styleProps = _$bJbxN$useStyleProps2.styleProps;
  var domRef = $bJbxN$useDOMRef(ref);
  return /*#__PURE__*/$bJbxN$react.createElement("section", _objectSpread(_objectSpread(_objectSpread({}, $bJbxN$filterDOMProps(otherProps)), styleProps), {}, {
    ref: domRef
  }), /*#__PURE__*/$bJbxN$react.createElement($bJbxN$ClearSlots, null, children));
}
/**
 * Content represents the primary content within a Spectrum container.
 */
var $0a7c18a2ef74b280$export$7c6e2c02157bb7d2 = /*#__PURE__*/$bJbxN$forwardRef($0a7c18a2ef74b280$var$Content);
function $8d68cc89c1f9278e$var$Footer(props, ref) {
  props = $bJbxN$useSlotProps(props, 'footer');
  var _props3 = props,
    children = _props3.children,
    otherProps = _objectWithoutProperties(_props3, _excluded3);
  var _$bJbxN$useStyleProps3 = $bJbxN$useStyleProps(otherProps),
    styleProps = _$bJbxN$useStyleProps3.styleProps;
  var domRef = $bJbxN$useDOMRef(ref);
  return /*#__PURE__*/$bJbxN$react.createElement("footer", _objectSpread(_objectSpread(_objectSpread({}, $bJbxN$filterDOMProps(otherProps)), styleProps), {}, {
    ref: domRef
  }), /*#__PURE__*/$bJbxN$react.createElement($bJbxN$ClearSlots, null, children));
}
/**
 * Footer represents a footer within a Spectrum container.
 */
var $8d68cc89c1f9278e$export$a06f1c675e846f6f = /*#__PURE__*/$bJbxN$forwardRef($8d68cc89c1f9278e$var$Footer);
function $aedcc4886d2a392a$var$Header(props, ref) {
  props = $bJbxN$useSlotProps(props, 'header');
  var _props4 = props,
    children = _props4.children,
    otherProps = _objectWithoutProperties(_props4, _excluded4);
  var _$bJbxN$useStyleProps4 = $bJbxN$useStyleProps(otherProps),
    styleProps = _$bJbxN$useStyleProps4.styleProps;
  var domRef = $bJbxN$useDOMRef(ref);
  return /*#__PURE__*/$bJbxN$react.createElement("header", _objectSpread(_objectSpread(_objectSpread({}, $bJbxN$filterDOMProps(otherProps)), styleProps), {}, {
    ref: domRef
  }), /*#__PURE__*/$bJbxN$react.createElement($bJbxN$ClearSlots, null, children));
}
/**
 * Header represents a header within a Spectrum container.
 */
var $aedcc4886d2a392a$export$8b251419efc915eb = /*#__PURE__*/$bJbxN$forwardRef($aedcc4886d2a392a$var$Header);
export { $b9606c0c41d55371$export$27a5bd065ad55220 as View, $0a7c18a2ef74b280$export$7c6e2c02157bb7d2 as Content, $8d68cc89c1f9278e$export$a06f1c675e846f6f as Footer, $aedcc4886d2a392a$export$8b251419efc915eb as Header };